module.exports = __webpack_public_path__ + "static/media/Sleeping.0b6d5602.png";